var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speech-recogintion-top",class:{
    'height-large': _vm.audioObj.isShowRecordPanel,
    'height-small': _vm.audioObj.hasClick && !_vm.audioObj.isShowRecordPanel,
  }},[_c('soundWave',{ref:"soundWave",staticStyle:{"width":"0px","margin":"0 auto"},attrs:{"showChat":false,"height":0},on:{"started":_vm.recordStarted,"process":_vm.recordProcess,"speechEnd":_vm.speechEnd,"stoped":_vm.recordStoped,"end":_vm.recordEnd}}),_c('audio',{ref:"audio"},[_c('source',{attrs:{"src":require("@/assets/out.mp3"),"type":"audio/mpeg"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }